export default __webpack_public_path__ + "static/media/data-science-banner.b5e15f43.png";